import { SVG } from '../svg';
import { IconProps } from '../types';

export function BoxBetweenLinesIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <rect width="6" height="10" x="9" y="7" rx="2" />
      <path d="M4 22V2" />
      <path d="M20 22V2" />
    </SVG>
  );
}
